export enum RingFinish {
  Silver = 'silver',
  Black = 'black',
  Stealth = 'stealth',
  Gold = 'gold',
  Rose = 'rose',
  Titanium = 'titanium',
}
